import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import {
  InterfaceNameValue,
  RadioButtonGroup,
  InterfaceRadioButtonOption,
} from '@tiendanube/components';
import { FreeShippingType } from 'domains/Catalog/Products/productsServices';

interface OnChangeValue {
  name: string;
  value: FreeShippingType;
}

interface StockProps {
  value: FreeShippingType;
  onChange: ({ name, value }: OnChangeValue) => void;
}
function FreeShipping({ value, onChange }: StockProps): JSX.Element {
  const { t } = useTranslation([Domain.CATALOG]);

  const options: FreeShippingType[] = ['', 'true', 'false'];

  const labelOptions: InterfaceRadioButtonOption[] = options.map((value) => ({
    value,
    label: t(`products.filters.freeShipping.${value || 'all'}`),
  }));

  const handleChange = (data: InterfaceNameValue) => {
    onChange(data as OnChangeValue);
  };

  return (
    <RadioButtonGroup
      label={t('products.filter.freeShipping')}
      name="freeShipping"
      options={labelOptions}
      onChange={handleChange}
      value={value}
    />
  );
}

export default FreeShipping;
